import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FolderDeleteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"folder_delete"}/>
}
